export enum CounterpartyType {
	UNKNOWN = "Unknown",
	LEGAL_ENTITY = "LegalEntity",
	PHYSICAL_PERSON = "Individual",
	LEGAL_PERSON = "Entrepreneur",
	FOREIGN_ORGANIZATION = "ForeignOrganization"
};
